import type { IShopper } from "@apis/shoppers/types"
import { Button } from "@components/ui/button"
import { formatDate } from "@utils/formatters"
import { Link } from "react-router-dom"

type TProspectPartialShopperProps = {
  prospectPartialShopper: Pick<IShopper, "initial_sale_dt" | "shopper_guid">
  prospect_guid: string
}

export const ProspectPartialShopper = ({
  prospectPartialShopper,
  prospect_guid,
}: TProspectPartialShopperProps) => {
  return (
    <Button
      variant="outline"
      className="tw:h-fit tw:items-start tw:gap-1"
      asChild
    >
      <Link
        to={`/prospect/${prospect_guid}/new_order?shopper_guid=${prospectPartialShopper.shopper_guid}`}
        className="tw:flex tw:flex-col"
      >
        <span className="tw:text-wrap">
          Saved date: {formatDate(prospectPartialShopper.initial_sale_dt)}
        </span>
      </Link>
    </Button>
  )
}
